import React, { Component } from 'react';
import { noop } from 'lodash';
import BackArrowView from './BackArrowView';
import { I_DONT_SEE_MY_PLAN } from '../ScanCardActions';
import { SectionHeader } from './StyledSectionComponents';
import SectionItemView from './SectionItemView';
import { CustomMetrics, INTERACTION_TYPES } from '@zocdoc/frontend-metrics';
import { EVENT_INITIATOR } from '../../../constants';

export class ScanCardPlanView extends Component {
    static defaultProps = {
        clickPlan: noop,
        clickBackToCarrier: noop,
    };

    render() {
        const { plans, clickBackToCarrier } = this.props;

        const empty = {
            plan_id: I_DONT_SEE_MY_PLAN,
            plan_name: "I don't see my insurance plan here",
        };

        return (
            // TODO Chris what about long carrier names
            <div>
                <SectionHeader data-test="insurance-picker-scan-card-back-arrow">
                    <BackArrowView
                        clickBack={clickBackToCarrier}
                        data-uem-id="insurance-picker-scan-card-back-arrow"
                        text="Select your plan"
                    />
                </SectionHeader>
                <div>
                    {plans.map((t, index) => this.renderInsurancePlanRow(t, index + 1))}
                    {this.renderInsurancePlanRow(empty, plans.length, true)}
                </div>
            </div>
        );
    }

    renderInsurancePlanRow(item, index, iDontSeeMyPlan = false) {
        const element = iDontSeeMyPlan ? 'IDontSeeMyPlan' : 'SelectYourPlan';
        const action = `Insurance Picker Scan - ${iDontSeeMyPlan ? 'Plan Selected' : "Clicked I Don't See Plan"}`;
        return (
            <CustomMetrics>
                {({ sendMetric }) => (
                    <SectionItemView
                        key={item.plan_id}
                        data-uem-id={`plan-${item.plan_id}`}
                        dataTest={`plan-${item.plan_id}`}
                        onClick={() => {
                            this.props.clickPlan(item, index, false);
                            sendMetric({
                                element,
                                action,
                                eventDetails: {
                                    PlanId: item.plan_id,
                                    Name: item.plan_name,
                                    Position: index,
                                },
                                initiator: EVENT_INITIATOR.USER,
                                interactionType: INTERACTION_TYPES.CLICK,
                            });
                        }}
                        text={item.plan_name}
                    />
                )}
            </CustomMetrics>
        );
    }
}
